(function createTitanScanShellView() {
  'use strict';

  function renderGameButtons(container, games) {
    const loadLabels = {
      light: 'LIGHT LOAD',
      medium: 'MID LOAD',
      heavy: 'HEAVY LOAD',
      ultra: 'ULTRA LOAD',
    };
    const buttons = games.map((game) => {
      const button = document.createElement('button');
      const marker = document.createElement('span');
      const copy = document.createElement('span');
      const name = document.createElement('strong');
      const descriptor = document.createElement('small');
      button.type = 'button';
      button.className = 'game-card';
      button.dataset.game = game.id;
      button.setAttribute('aria-pressed', 'false');
      marker.className = 'load-marker';
      marker.textContent = loadLabels[game.load];
      name.textContent = game.shortName;
      descriptor.textContent = game.descriptor;
      copy.append(name, descriptor);
      button.append(marker, copy);
      return button;
    });
    container.replaceChildren(...buttons);
  }

  function renderControls(refs, state, logic) {
    refs.gameGrid.querySelectorAll('[data-game]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.game === state.answers.game));
    });
    refs.root.querySelectorAll('input[name="style"]').forEach((input) => {
      input.checked = input.value === state.answers.style;
    });
    refs.root.querySelectorAll('input[name="priority"]').forEach((input) => {
      input.checked = input.value === state.answers.priority;
    });
    refs.root.querySelectorAll('input[name="streaming"]').forEach((input) => {
      input.checked = input.value === state.answers.streaming;
    });
    refs.monitorGrid.querySelectorAll('[data-monitor]').forEach((button) => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.monitor) === state.answers.monitorHz));
    });
    refs.budgetRange.value = String(state.answers.budget);
    refs.budgetRange.disabled = state.answers.budgetUnlimited;
    refs.budgetUnlimited.checked = state.answers.budgetUnlimited;
    refs.budgetOutput.textContent = state.answers.budgetUnlimited ? '上限なし' : logic.formatYen(state.answers.budget);
    const budgetValueText = state.answers.budgetUnlimited
      ? '予算上限なし'
      : `${Math.round(state.answers.budget / 10000)}万円`;
    refs.budgetRange.setAttribute('aria-valuetext', budgetValueText);
    refs.gameNext.disabled = !state.answers.game;
    refs.profileNext.disabled = !(state.answers.style && state.answers.monitorHz);
    refs.preferencesNext.disabled = !(state.answers.priority && state.answers.streaming);
  }

  function renderSound(refs, state) {
    const isOn = !state.preferences.muted;
    refs.soundLabel.textContent = isOn ? '音声 ON' : '音声 OFF';
    refs.soundToggle.setAttribute('aria-pressed', String(isOn));
    refs.soundToggle.setAttribute('aria-label', isOn ? '効果音をオフにする' : '効果音をオンにする');
  }

  function focusScreen(root, screen, testScreens) {
    requestAnimationFrame(() => {
      const activeScreen = root.querySelector(`#${screen}`);
      let target = activeScreen?.querySelector('[data-screen-title]');
      if (testScreens.has(screen)) target = activeScreen?.querySelector('[data-test-primary]');
      if (target) target.focus({ preventScroll: true });
      if (!testScreens.has(screen)) {
        activeScreen?.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    });
  }

  function createVideoController(video, toggle, root, reducedMotionQuery, getScreen) {
    let preference = 'auto';
    let playRequest = 0;
    function renderToggle() {
      const paused = video.paused;
      toggle.textContent = paused ? '動画を再生' : '動画を一時停止';
      toggle.setAttribute('aria-pressed', String(!paused));
    }
    function sync() {
      const requestId = ++playRequest;
      const userRequestedPlay = preference === 'playing';
      const shouldPlay =
        getScreen() === 'intro' &&
        preference !== 'paused' &&
        (!reducedMotionQuery.matches || userRequestedPlay);
      if (!shouldPlay) {
        video.pause();
        renderToggle();
        return;
      }
      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt
          .then(() => {
            if (requestId === playRequest) renderToggle();
          })
          .catch((error) => {
            if (requestId !== playRequest || error?.name === 'AbortError') return;
            if (error?.name === 'NotAllowedError') {
              video.pause();
              renderToggle();
              return;
            }
            root.classList.add('tps-v2-video-unavailable');
          });
      } else {
        renderToggle();
      }
    }
    function togglePlayback() {
      preference = video.paused ? 'playing' : 'paused';
      sync();
    }
    toggle.addEventListener('click', togglePlayback);
    video.addEventListener('play', renderToggle);
    video.addEventListener('pause', renderToggle);
    return Object.freeze({ sync });
  }

  window.TitanScanShellView = Object.freeze({
    createVideoController,
    focusScreen,
    renderControls,
    renderGameButtons,
    renderSound,
  });
})();
